import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
// import $ from 'jquery-ui';

/**
 * tab 을 클릭하면 해당 content 가 보여지고 나머지 content는 사라집니다. <br>
 * tab 과 content 는 index가 같은 걸로 연결합니다.
 */
export default class TypingText extends Controller {
  static targets = ['text'];
  static values = { contentIdx: Number };
  static timeoutCallbacks = [];
  #inProgress = false;

  connect() {
    window.addEventListener('accordionContentShowEvent', (evt) => {
      const { selectedIdx } = evt.detail;
      if (this.contentIdxValue === selectedIdx) {
        this.initText();
        this.typeText();
      }
    });
    const typingTextInitEvent = new CustomEvent('typingTextInitEvent', {
      detail: { selectedIdx: this.contentIdxValue },
    });
    window.dispatchEvent(typingTextInitEvent);

    const self = this;
    $(window).on('scroll', () => {
      if (self.checkVisible(self.element, false)) {
        self.typeText();
      } else {
        self.initText();
      }
    });
  }

  typeText() {
    if (this.#inProgress) {
      return;
    }
    const speed = 50;
    const text = this.textTarget;
    const typing = async () => {
      this.#inProgress = true;
      await this.wait(speed);
      text.classList.add('revealed');
      this.#inProgress = false;
    };
    typing();
  }

  async initText() {
    this.#inProgress = false;
    const text = this.textTarget;
    text.classList.remove('revealed');
    text.classList.add('hidden');
  }

  wait(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }

  checkVisible(elm, evaluate) {
    evaluate = evaluate || 'object visible';
    var viewportHeight = $(window).height(), // Viewport Height
      scrolltop = $(window).scrollTop(), // Scroll Top
      y = $(elm).offset().top,
      elementHeight = $(elm).height();
    if (evaluate == 'object visible') return y < viewportHeight + scrolltop && y > scrolltop - elementHeight;
    if (evaluate == 'above') return y < viewportHeight + scrolltop;
  }
}
